import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { notification } from "antd";
import { I18n } from "@aws-amplify/core";

import { Service } from "@/infra/services/bera";

export interface GetStepKeyResultsParams {
	organization_id: string;
	company_id: string;
	custom_report_step_key_id: string;
	bera_report_id: string;
}

export type GetStepKeyResultsResponse = {
	id: string;
	task_rpn: number;
	job_element: string;
	stress_level_id: string;
	frequency_id: string;
	total_task_duration_id: string;
	step_key_id: string;
	step_id: string;
	action_plan_id: string;
};

export const useGetBeraStepKeyResult = () => {
	return useMutation<GetStepKeyResultsResponse, AxiosError<Response>, GetStepKeyResultsParams>((params: GetStepKeyResultsParams) => Service.getStepKeyResult(params), {
		onError: (err: any) => {
			const typeError = err.response.data.details[0]?.split('" ') ?? err;
			notification.error({
				message: I18n.get('Ops... something happened!'),
				description: I18n.get(typeError[1])
			});
		}
	});
};